import * as Yup from 'yup';

import { PROFILE_FIELD_OTHER_VALUE } from '@utils/backend-api/profileSettings';

const schema = () =>
  Yup.object().shape({
    company: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please enter an organization'),
    }),
    companySize: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }),
    customIndustry: Yup.object().when('industry', (industry) => {
      return Yup.object().shape({
        label: Yup.string(),
        value: Yup.lazy((value) => {
          if (industry && industry.value === PROFILE_FIELD_OTHER_VALUE) {
            return typeof value === 'number'
              ? Yup.number().min(1, 'Please enter an industry')
              : Yup.string().required('Please enter an industry');
          }
          return Yup.mixed();
        }),
      });
    }),
    customJobFunction: Yup.object().when('jobFunction', (jobFunction) => {
      return Yup.object().shape({
        label: Yup.string(),
        value: Yup.lazy((value) => {
          if (jobFunction && jobFunction.value === PROFILE_FIELD_OTHER_VALUE) {
            return typeof value === 'number'
              ? Yup.number().min(1, 'Please enter a job function')
              : Yup.string().required('Please enter a job function');
          }
          return Yup.mixed();
        }),
      });
    }),
    customJobLevel: Yup.object().when('jobLevel', (jobLevel) => {
      return Yup.object().shape({
        label: Yup.string(),
        value: Yup.lazy((value) => {
          if (jobLevel && jobLevel.value === PROFILE_FIELD_OTHER_VALUE) {
            return typeof value === 'number'
              ? Yup.number().min(1, 'Please enter a job level')
              : Yup.string().required('Please enter a job level');
          }
          return Yup.mixed();
        }),
      });
    }),
    customSubIndustry: Yup.object().when('subIndustry', (subIndustry) => {
      return Yup.object().shape({
        label: Yup.string(),
        value: Yup.lazy((value) => {
          if (subIndustry && subIndustry.value === PROFILE_FIELD_OTHER_VALUE) {
            return typeof value === 'number'
              ? Yup.number().min(1, 'Please enter a sub industry')
              : Yup.string().required('Please enter a sub industry');
          }
          return Yup.mixed();
        }),
      });
    }),
    customSubJobFunction: Yup.object().when('subJobFunction', (subJobFunction) => {
      return Yup.object().shape({
        label: Yup.string(),
        value: Yup.lazy((value) => {
          if (subJobFunction && subJobFunction.value === PROFILE_FIELD_OTHER_VALUE) {
            return typeof value === 'number'
              ? Yup.number().min(1, 'Please enter a sub job function')
              : Yup.string().required('Please enter a sub job function');
          }
          return Yup.mixed();
        }),
      });
    }),
    firstName: Yup.string().required('Please enter a first name'),
    industry: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please select an industry'),
    }),
    jobFunction: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please select a job function'),
    }),
    jobLevel: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please select a job level'),
    }),
    lastName: Yup.string().required('Please enter a last name'),
    postalCode: Yup.string().min(5, 'Please enter a valid postal code'),
    subIndustry: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please select a sub industry'),
    }),
    subJobFunction: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string().required('Please select a sub job function'),
    }),
    jobTitle: Yup.object().shape({
      label: Yup.string(),
      value: Yup.mixed(),
    }),
  });

export default schema;
